import type { ReactNode } from 'react'
import { cm } from '~/utils/utils'
import { Tag } from './Tag'

interface Props {
  title: string | ReactNode
  content?: string
  children?: ReactNode
  className?: string
  isConnected?: boolean
  variant?: 'default' | 'card'
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}

export function SettingItem({
  title,
  content,
  children,
  className,
  isConnected = false,
  variant = 'default',
  onClick
}: Props) {
  if (variant === 'card') {
    return (
      <div
        className={cm(
          'w-full min-w-[320px] max-w-[400px] h-[80px] p-6 rounded-2xl border border-[#EAEAEA] bg-[#FCFCFC]',
          'dark:border-tokens-neutral-border-2 dark:bg-tokens-neutral-bg-grey-2',
          'hover:bg-[#F5F5F5] dark:hover:bg-tokens-neutral-fill-fill-4 transition-colors duration-200 ease-in-out cursor-pointer',
          className
        )}
        onClick={onClick}
      >
        <div className='flex items-center justify-between w-full h-8'>
          {/* Left side: icon, title and CONNECTED tag */}
          <div className='flex items-center gap-3 flex-1 font-semibold'>
            {title}
            {/* CONNECTED tag next to the name */}
            {isConnected && (
              <Tag variant='success' className='w-[71px] h-4'>
                CONNECTED
              </Tag>
            )}
          </div>

          {/* Right side: action buttons */}
          <div className='flex items-center'>{children}</div>
        </div>
      </div>
    )
  }

  return (
    <div className={cm('settings-item w-full flex justify-between items-center py-3', className)}>
      <div className='settings-item_left'>
        <div className='settings-title mb-1'>{title}</div>
        {content ? (
          <div className='settings-content text-gray-500 dark:text-gray-400'>{content}</div>
        ) : null}
      </div>
      <div className='settings-item_right'>{children}</div>
    </div>
  )
}
